/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { css, jsx } from '@emotion/core';
import imgSrc from 'images/animation.gif';

function MainPage(): Element<string> {
  return (
    <div
      css={css(`
    background: #162d54;
    z-index: 1000;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  `)}
    >
      <img src={imgSrc} css={css('max-height: 300px;')} />
    </div>
  );
}

export default MainPage;
